/* Animate on entry without hiding content or adding scroll listeners. */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!document.body.classList.contains('bossio-home') || !('IntersectionObserver' in window)) return;

  const played = new WeakSet();
  const observed = new Set();
  const active = new Set();
  const selector = [
    '.bossio-editorial:not(.bossio-editorial--hero) > .bossio-editorial__media',
    '.bossio-editorial:not(.bossio-editorial--hero) > .bossio-editorial__copy',
    '.bossio-designers__intro', '.bossio-designers__list > a',
    '.bossio-section-heading', '.bossio-product', '.bossio-newsletter > div',
    '.bossio-newsletter__form',
  ].join(',');

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      // Wait until the block is actually readable, not just one pixel inside the viewport.
      if (!entry.isIntersecting || entry.intersectionRatio < 0.12) continue;
      const element = entry.target;
      observer.unobserve(element);
      observed.delete(element);
      if (motion.matches || !element.animate || element.contains(document.activeElement)) continue;
      played.add(element);
      const siblings = element.matches('.bossio-product, .bossio-designers__list > a')
        ? [...element.parentElement.children]
        : [];
      const delay = Math.min(Math.max(siblings.indexOf(element), 0) * 90, 270);
      // No inline visibility state: a failed or disabled script leaves the page intact.
      const animation = element.animate(
        [{ opacity: 0.35, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 850, delay, fill: 'backwards', easing: 'cubic-bezier(.22, 1, .36, 1)' },
      );
      active.add(animation);
      const clear = () => active.delete(animation);
      animation.addEventListener('finish', clear, { once: true });
      animation.addEventListener('cancel', clear, { once: true });
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function observe(root = document) {
    if (motion.matches || window.Shopify?.designMode) return;
    for (const element of root.querySelectorAll(selector)) {
      if (played.has(element) || observed.has(element)) continue;
      observed.add(element);
      observer.observe(element);
    }
  }

  motion.addEventListener('change', () => {
    if (motion.matches) {
      observer.disconnect();
      observed.clear();
      for (const animation of active) animation.cancel();
    } else {
      observe();
    }
  });
  document.addEventListener('focusin', (event) => {
    for (const animation of active) {
      if (animation.effect?.target?.contains(event.target)) animation.cancel();
    }
  });
  observe();
})();
